export default __webpack_public_path__ + "static/1-92586372f31965b6cc75b17348a7403b.jpg";